

























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import UserAvatar from '@/views/components/userAvatar.vue';
import { OncallWeekdayList } from '@/config/map.conf';
import ColorSelect from '../colorSelect.vue';
import * as api from '@/api';

@Component({
    components: {
        UserAvatar,
        ColorSelect
    }
})
export default class CellShiftModal extends Vue {
    @Prop({ default: false }) visible: boolean;
    @Prop({ default: () => ({}) }) member: CommonTypes.mapObject;
    @Prop({ default: 0 }) timestamp: number;
    @Prop({ default: () => [] }) shift: CommonTypes.mapObject[];
    @Prop({
        default: () => ({
            left: 0,
            top: 0
        })
    })
    positionMap: CommonTypes.mapObject;

    weekDayMap: CommonTypes.mapObject[] = OncallWeekdayList;
    selectedShiftList: CommonTypes.mapObject[] = [];
    showModal: boolean = false;
    btnLoading: boolean = false;

    @Watch('visible', { immediate: true })
    onVisibleChanged() {
        this.showModal = this.visible;
        this.$nextTick(() => {
            this.changeModalStyle();
        });
    }
    @Watch('shift', { deep: true, immediate: true })
    onShift() {
        this.onShiftChanged(this.shift);
    }
    cancel() {
        this.$emit('close');
        this.$emit('update:visible', false);
    }
    onShiftChanged(options) {
        this.selectedShiftList = options.filter(item => item.selected);
    }
    changeModalStyle() {
        const modalDom: any = document.getElementById('date-edit-modal')?.getElementsByClassName('mtd-modal')[0];
        modalDom.style.top = `${this.positionMap.top}px`;
        modalDom.style.marginLeft = `${this.positionMap.left}px`;
    }

    async confirm() {
        this.btnLoading = true;
        try {
            const hasWholeDayShift = !!this.selectedShiftList.find(item => item.color === 'ALL');
            const shiftWithoutWholeDay = hasWholeDayShift ? this.selectedShiftList.filter(item => item.color !== 'ALL') : this.selectedShiftList;
            const res = await api.oncallApi.updateOncallTableByDate({
                rgId: this.rgId,
                mis: this.member.identify,
                date: this.timestamp,
                shift: shiftWithoutWholeDay.map(item => item.id),
                wholeDay: hasWholeDayShift
            });
            const { code } = res;
            if (code === 200) {
                this.$mtd.message.success('编辑值班信息成功');
                this.btnLoading = false;
                this.$emit('success');
                this.cancel();
            }
        } catch (error) {
            this.btnLoading = false;
        }
    }
    get title() {
        const date = new Date(this.timestamp);
        return ` ${date.getMonth() + 1}月${date.getDate()}日（${this.weekDayMap.find(item => item.value === date.getDay() + 1).label}）的值班`;
    }
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
